import React from 'react';
import FullPageSection from './FullPageSection';
import './ProcessSection.css';

const ProcessSection = () => {
    const steps = [
        {
            number: '01',
            title: 'Briefing & Descoberta',
            description: 'Conhecemos a sua marca, objetivos e desafios. Fazemos uma análise profunda do mercado e da concorrência.',
        },
        {
            number: '02',
            title: 'Estratégia & Conceito',
            description: 'Definimos a estratégia criativa e o posicionamento da marca. Desenvolvemos conceitos alinhados com os seus objetivos.',
        },
        {
            number: '03',
            title: 'Design & Criação',
            description: 'Transformamos conceitos em design. Criamos identidades visuais, interfaces e materiais de comunicação.',
        },
        {
            number: '04',
            title: 'Revisão & Refinamento',
            description: 'Trabalhamos em colaboração para aperfeiçoar cada detalhe até atingir a excelência.',
        },
        {
            number: '05',
            title: 'Implementação',
            description: 'Entregamos todos os assets e apoiamos na implementação da nova identidade em todos os pontos de contacto.',
        },
    ];

    return (
        <FullPageSection id="process" className="process-section">
            <div className="process-container">
                <div className="process-header">
                    <span className="section-label">Como trabalhamos</span>
                    <h2 className="section-title">
                        Processo<br />
                        Colaborativo
                    </h2>
                    <p className="section-description">
                        Um método testado que combina estratégia, criatividade e execução impecável
                    </p>
                </div>

                <div className="process-steps">
                    {steps.map((step, index) => (
                        <div key={index} className="process-step">
                            <div className="step-number">{step.number}</div>
                            <div className="step-content">
                                <h3 className="step-title">{step.title}</h3>
                                <p className="step-description">{step.description}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </FullPageSection>
    );
};

export default ProcessSection;
